try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_leave_117_g_min.mp3?v=1752138247",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_luv_u_133_b_min.mp3?v=1752138247",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_never_ends_135_d_min.mp3?v=1752138246",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_otherside_105_c_min.mp3?v=1752138247"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/grow_leave.json?v=1752138244",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/grow_luv_u.json?v=1752138245",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_never_ends.json?v=1752138244",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/grow_otherside.json?v=1752138245"
  ];

  const elements = document.querySelectorAll('#player-set-114 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_leave_117_g_min.mp3?v=1752138247",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_luv_u_133_b_min.mp3?v=1752138247",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_never_ends_135_d_min.mp3?v=1752138246",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_otherside_105_c_min.mp3?v=1752138247"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/grow_leave.json?v=1752138244",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/grow_luv_u.json?v=1752138245",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/glow_never_ends.json?v=1752138244",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/grow_otherside.json?v=1752138245"
  ];

  const elements = document.querySelectorAll('#player-set-4 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_always_yap_133_g_min.mp3?v=1752138252",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_just_want_you_157_a_min.mp3?v=1752138253",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_ruhyped_140_a_min.mp3?v=1752138253",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_without_you_137_b_min.mp3?v=1752138252"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_always_yap.json?v=1752138250",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_just_want_you.json?v=1752138250",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_ruhyped.json?v=1752138251",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_without_you.json?v=1752138251"
  ];

  const elements = document.querySelectorAll('#player-set-5 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_5_136_c_min.mp3?v=1752138243",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_7_130_d_min.mp3?v=1752138245",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_18_127_c_min.mp3?v=1752138243",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_20_129_d_min.mp3?v=1752138242"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_5.json?v=1752138241",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_7.json?v=1752138240",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_18.json?v=1752138241",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_20.json?v=1752138242"
  ];

  const elements = document.querySelectorAll('#player-set-6 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_jersey_kick.wav?v=1752138239",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_pop_vox.wav?v=1752138238",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_tingle_snap.wav?v=1752138238",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_classic_-_gun_sound.wav?v=1752138238"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_jersey_kick.json?v=1752138238",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_pop_vox.json?v=1752138237",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_tingle_snap.json?v=1752138237",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_classic_gun_sound.json?v=1752138238"
  ];

  const elements = document.querySelectorAll('#player-set-7 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_glock_136.mp3?v=1752138249",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_stormy_127_DRUML.mp3?v=1752138250",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_bed_squeak_125.mp3?v=1752138249",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_shooting_132.mp3?v=1752138249"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_glock.json?v=1752138248",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_stormy.json?v=1752138248",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_bed_squeak.json?v=1752138248",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/percloops_shooting.json?v=1752138247"
  ];

  const elements = document.querySelectorAll('#player-set-8 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_always_yap_133_g_min.mp3?v=1752138252",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_just_want_you_157_a_min.mp3?v=1752138253",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_ruhyped_140_a_min.mp3?v=1752138253",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_without_you_137_b_min.mp3?v=1752138252"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_always_yap.json?v=1752138250",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_just_want_you.json?v=1752138250",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_ruhyped.json?v=1752138251",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/spice_without_you.json?v=1752138251"
  ];

  const elements = document.querySelectorAll('#player-set-115 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_5_136_c_min.mp3?v=1752138243",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_7_130_d_min.mp3?v=1752138245",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_18_127_c_min.mp3?v=1752138243",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_20_129_d_min.mp3?v=1752138242"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_5.json?v=1752138241",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_7.json?v=1752138240",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_18.json?v=1752138241",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/gloss_midi_20.json?v=1752138242"
  ];

  const elements = document.querySelectorAll('#player-set-116 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_jersey_kick.wav?v=1752138239",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_pop_vox.wav?v=1752138238",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_tingle_snap.wav?v=1752138238",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_classic_-_gun_sound.wav?v=1752138238"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_jersey_kick.json?v=1752138238",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_pop_vox.json?v=1752138237",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_tingle_snap.json?v=1752138237",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/pulse_classic_gun_sound.json?v=1752138238"
  ];

  const elements = document.querySelectorAll('#player-set-117 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
